import * as graphql from 'generated/graphql';
import _ from 'lodash';

import { ITypeSpecificPolicy } from './shared';



export const MessageData: ITypeSpecificPolicy<graphql.MessageData> = {

  fields: {
    values: {
      read: (existing: graphql.MessageDataValue[]) => {
        return _.sortBy(existing, (val) => {
          return val.year + val.period;
        });
      }
    }
  }
};
